import React from "react";

const getLoginUrl = () => {
  const loginUrl = typeof window !== "undefined" && /lyriclious\.com$/i.test(window.location.hostname)
    ? "https://www.lyriclious.com/login"
    : process.env.REACT_APP_LYRICLIOUS_LOGIN_URL || "http://localhost:3000/login";
  const returnUrl = typeof window !== "undefined"
    ? (() => {
      const workspaceUrl = new URL(window.location.href);
      workspaceUrl.search = "";
      workspaceUrl.searchParams.set("workspace-login", "1");
      workspaceUrl.hash = "";
      return workspaceUrl.toString();
    })()
    : "";

  return returnUrl ? `${loginUrl}?returnUrl=${encodeURIComponent(returnUrl)}` : loginUrl;
};

export function WorkspaceErrorNotice({ message }) {
  if (!message) return null;

  const isAuthError = /login|sign in|access/i.test(message);

  return (
    <div className="workspace-error-notice">
      <p>{message}</p>
      {isAuthError ? (
        <a href={getLoginUrl()}>
          Sign in with Lyriclious
        </a>
      ) : null}
    </div>
  );
}
